var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-badge",class:( _obj = {
    'type-default': _vm.isTypeSale || _vm.isTypeCustom,
    'type-clearance': _vm.isTypeClearance
  }, _obj[_vm.size] = _vm.size, _obj )},[_c('div',{staticClass:"badge-text"},[(_vm.isTypeSale)?[_c('span',[_vm._v("Sale")])]:(_vm.isTypeClearance)?[_c('span',[_vm._v("Last Chance")])]:(_vm.isTypeCustom)?[(_vm.text)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e()]:_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }